// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"218":"1d868871","594":"81c28ba9"}[chunkId] + ".js";
};